import { FC, PropsWithChildren } from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { Container } from './main/Main';

interface Props extends PropsWithChildren {
  back?: {
    to: string;
    text: string;
  };
}

export const PageHeader: FC<Props> = ({ children, back }) => {
  const navigate = useNavigate();

  return (
    <div className="border-secondary-std flex h-28 items-center border-b bg-white bg-opacity-80">
      <Container animate="fade">
        {back && (
          <button onClick={() => navigate(back.to)} className="flex items-center gap-2">
            <FiChevronLeft />
            <span>{back.text}</span>
          </button>
        )}
        <div className="text-3xl font-bold">{children}</div>
      </Container>
    </div>
  );
};
